function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  clipRule: "evenodd",
  d: "M6.5 14a6.5 6.5 0 100-13 6.5 6.5 0 000 13z",
  stroke: "currentColor"
});

var SvgCircleCheck = function SvgCircleCheck(props) {
  return React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml,%3Csvg width='14' height='15' viewBox='0 0 14 15' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M6.5 14C10.0899 14 13 11.0899 13 7.5C13 3.91015 10.0899 1 6.5 1C2.91015 1 0 3.91015 0 7.5C0 11.0899 2.91015 14 6.5 14Z' stroke='currentColor' /%3E %3C/svg%3E";
export { SvgCircleCheck as ReactComponent };